import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import {
    List,
    Paper,
    TextField,
    Tooltip,
    Dialog,
    IconButton,
    DialogContent,
    CircularProgress
} from '@mui/material';
import {
    MdArrowBack,
    MdAttachEmail,
    MdDelete, MdError,
    MdFileUpload,
    MdGroup,
    MdInsertDriveFile, MdOutlineEditNote,
    MdSend,
    MdVisibility
} from "react-icons/md";
import {HttpTransportType, HubConnectionBuilder} from "@microsoft/signalr";
import {jwtDecode} from "jwt-decode";
import CloseIcon from '@mui/icons-material/Close';
import "./ChatComponent.css";
import {
    FaCommentDots,
    FaFile,
    FaFileExcel,
    FaFilePdf,
    FaFilePowerpoint,
    FaFileWord,
    FaTimesCircle
} from "react-icons/fa";
import {IoIosCloseCircleOutline} from "react-icons/io";
import CreateChatGroupPopup from "./CreateChatGroupPopup";
import EditChatGroupPopup from "./EditChatFroupPopup";
import CreateChatOneToOne from "./CreateChatOneToOne";
import ChatComponentHeader from "./ChatComponentHeader";
import {FiUser, FiUsers} from "react-icons/fi";

const ChatComponent = ({
                           open,
                           onClose,
                           isCaseChat = false,
                           groupId = null,
                           onUnseenMessagesCountUpdate,
                           groupUsers = [],
                           chatName = '',
                           mainGroup,
                           onCaseChatUpdate
                       }) => {
    const [messages, setMessages] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const pageRef = useRef(0);
    const scrollRef = useRef(null);
    const initialLoadComplete = useRef(false);
    const [users, setUsers] = useState([]);
    const [activeChatGroupId, setActiveChatGroupId] = useState(groupId);
    const [currentMessage, setCurrentMessage] = useState('');
    const [messageSending, setMessageSending] = useState(false);
    const [userId, setUserId] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [connection, setConnection] = useState(null);
    const [chatGroupsAreLoading, setChatGroupsAreLoading] = useState(true);
    const [chatGroups, setChatGroups] = useState([]);
    const [file, setFile] = useState(null);
    const [emojiPickerVisible, setEmojiPickerVisible] = useState(false);
    const [showCreateChatPopup, setShowCreateChatPopup] = useState(false);
    const [showCreateOneToOneChatPopup, setShowCreateOneToOneChatPopup] = useState(false);
    const [showEditChatPopup, setShowEditChatPopup] = useState(false);
    const [fileError, setFileError] = useState('');
    const emojiPickerRef = useRef(null);
    const [filePreviewUrl, setFilePreviewUrl] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [previousChatGroupId, setPreviousChatGroupId] = useState(null);
    const [roleId, setRoleId] = useState("");
    const jwtToken = localStorage.getItem('jwtToken');
    const EMOJIS = [
        "😀", "😃", "😄", "😁", "😆", "😅", "😂", "🤣", "😊", "😇",
        "🙂", "🙃", "😉", "😌", "😍", "🥰", "😘", "😗", "😙", "😚",
        "😋", "😛", "😜", "🤪", "😝", "🤑", "🤗", "🤭", "🤫", "🤔",
        "🤐", "🤨", "😐", "😑", "😶", "😏", "😒", "🙄", "😬", "🤥",
    ];


    useEffect(() => {
        if (!isCaseChat) {
            const unseenMessagesCount = chatGroups.reduce((total, group) => total + group.notSeeenMessages, 0);
            onUnseenMessagesCountUpdate(unseenMessagesCount);
        }

    }, [chatGroups]);


    useEffect(() => {
        if (open && groupId) {
            setPreviousChatGroupId(groupId);
        }
    }, [open, groupId]);

    const updateSeenMessages = async (chatGroupId) => {
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/UpdateChatMessageByChatGroupId`, {
                chatGroupID: chatGroupId
            });
        } catch (error) {
            console.error('Failed to update seen messages:', error);
        }
    };

    useEffect(() => {
        if ("Notification" in window) {
            if (Notification.permission !== "granted" && Notification.permission !== "denied" && roleId && roleId !== "USER" && roleId !== "ROOTADMIN") {
                Notification.requestPermission().then(permission => {});
            }
        } else {
        }
    }, [jwtToken, roleId]);



    const handleChatGroupClick = (groupId) => {
        if (previousChatGroupId && previousChatGroupId !== groupId) {
            void updateSeenMessages(previousChatGroupId);
        }

        setPreviousChatGroupId(groupId);
        setActiveChatGroupId(groupId);
        void updateSeenMessages(groupId);
        setChatGroups((prevGroups) =>
            prevGroups.map((g) =>
                g.id === groupId
                    ? {...g, notSeeenMessages: 0}
                    : g
            )
        );
    };


    const handleEditChatGroup = (group) => {
        setSelectedGroup(group)
        setShowEditChatPopup(true);
    };

    useEffect(() => {
        if (chatGroups.length !== 0 && isCaseChat) {
            setActiveChatGroupId(groupId)
        }

    }, [chatGroups, open]);

    const addEmoji = (emoji) => {
        setCurrentMessage(currentMessage + emoji);
    };
    const resetFileInput = () => {
        document.getElementById('file-upload').value = "";
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            if (selectedFile.size > 15728640) {
                setFileError('ფაილის მაქსიმალური ზომა - 15 მეგაბაიტი!');
                setFile(null);
                setFilePreviewUrl(null);
            } else {
                setFile(selectedFile);
                setFilePreviewUrl(URL.createObjectURL(selectedFile));
                setFileError('');
            }
        }
        e.target.value = "";
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
                setEmojiPickerVisible(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        function handleClickOutside(event) {
            if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
                setEmojiPickerVisible(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const toggleCreateChatPopup = () => {
        setShowCreateChatPopup(!showCreateChatPopup);
    };
    const toggleCreateOneToOneChatPopup = () => {
        setShowCreateOneToOneChatPopup(!showCreateOneToOneChatPopup);
    };

    const toggleEditChatPopup = () => {
        setShowEditChatPopup(!showEditChatPopup);
    };
    const fetchChatGroups = async () => {
        setChatGroupsAreLoading(true)
        try {

            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetMyChatGroupes`);
            const chatGroupsData = response.data.data.reverse();
            setChatGroups(chatGroupsData);

        } catch (error) {
            console.error('Failed to fetch chat groups:', error);
        } finally {
            setChatGroupsAreLoading(false)
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            if (event.shiftKey) {
                setCurrentMessage((prevMessage) => prevMessage + "\n");
            } else if (event.ctrlKey) {
                setCurrentMessage((prevMessage) => prevMessage + "\n");
            } else {
                event.preventDefault();
                void sendMessage();
            }
        }
    };

    const fileIcon = (filePath) => {
        const extension = filePath.split('.').pop().toLowerCase();
        const iconStyles = {fontSize: '24px', cursor: 'pointer'};

        switch (extension) {
            case 'docx':
            case 'doc':
                return <FaFileWord style={{...iconStyles, color: '#3b82f6'}}/>; // Modern blue for Word documents
            case 'xlsx':
            case 'xls':
                return <FaFileExcel style={{...iconStyles, color: '#22c55e'}}/>; // Fresh green for Excel files
            case 'pptx':
                return <FaFilePowerpoint style={{...iconStyles, color: '#f97316'}}/>; // Vibrant orange for PowerPoint presentations
            case 'pdf':
                return <FaFilePdf style={{...iconStyles, color: '#ef4444'}}/>; // Bright red for PDF files
            case 'zip':
            case 'rar':
            case '7z':
                return <MdInsertDriveFile style={{...iconStyles, color: '#9ca3af'}}/>; // Neutral gray for compressed files
            default:
                return <FaFile style={{...iconStyles, color: '#d1d5db'}}/>; // Light grey for unknown file types
        }
    };


    useEffect(() => {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserId(decoded.UserId);
                setRoleId(decoded.role);
            } catch (error) {
                console.error('Error decoding token:', error);
            }
        }
    }, []);

    const fetchUsers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetAllInternalUsers`);
            const sortedUsers = response.data.data.result.sort((a, b) => a.firstName.localeCompare(b.firstName));
            setUsers(sortedUsers);
        } catch (error) {
            console.error('Failed to fetch users:', error);
        } finally {
        }
    };

    useEffect(() => {
        if (roleId === "HEADOFAGENCY" ||
            roleId === "DEPUTYHEADOFAGENCY" ||
            roleId === "HEADOFDEPARTMENT" ||
            roleId === "EXPERT"
        ) {
            void fetchChatGroups();
            void fetchUsers();
        }

    }, [roleId]);

    useEffect(() => {
        setHasMore(true)
        pageRef.current = 0;
        if (open) {
            void fetchMessages(true);
        }
    }, [activeChatGroupId, open]);

    const handleChange = (e) => {
        setCurrentMessage(e.target.value);
    };

    function parseMessageString(messageString) {
        const messageParts = messageString.split('+&*');
        const messageObj = {};

        messageParts.forEach(part => {
            const [key, value] = part.split('-$-');
            messageObj[key.trim()] = value.trim();
        });

        return messageObj;
    }

    const checkIfUserInGroup = (userId, groupId) => {
        const parsedGroupId = parseInt(groupId, 10);

        const group = chatGroups.find(group => group.id === parsedGroupId);

        return !!(group && group.chatUsersIds.includes(userId));
    };


    useEffect(() => {
        if (roleId) {
            if (roleId !== "USER" && roleId !== "ROOTADMIN") {
                const newConnection = new HubConnectionBuilder()
                    .withUrl(`${process.env.REACT_APP_API_BASE_URL}/hubs`, {
                        skipNegotiation: true,
                        transport: HttpTransportType.WebSockets
                    })
                    .build();

                setConnection(newConnection);

                newConnection.start()
                    .then(() => {
                    })
                    .catch(error => console.error('Error starting connection:', error));

                newConnection.on("ReceiveMessage", messageString => {
                    const messageObj = parseMessageString(messageString);
                    const receivedChatGroupId = parseInt(messageObj.chatGroupId);
                    const isNewChatGroup = chatGroups.find(chat => chat.id === receivedChatGroupId)

                    if (!isNewChatGroup && !isCaseChat) {
                        void fetchChatGroups();
                    }


                    if (userId !== messageObj.creatorUserID && checkIfUserInGroup(userId, messageObj.chatGroupId)) {
                        showNotification(messageObj);
                    }
                    setMessages(prevMessages => [...prevMessages, messageObj]);

                    setChatGroups(prevGroups => {
                        const groupIndex = prevGroups.findIndex(group => group.id === parseInt(messageObj.chatGroupId));

                        if (groupIndex !== -1) {
                            const updatedGroup = {
                                ...prevGroups[groupIndex],
                                notSeeenMessages: parseInt(messageObj.chatGroupId) !== activeChatGroupId ? prevGroups[groupIndex].notSeeenMessages + 1 : 0
                            };

                            const updatedGroups = [...prevGroups];
                            updatedGroups.splice(groupIndex, 1); // Remove the group from its current position
                            updatedGroups.unshift(updatedGroup); // Add the group to the top

                            return updatedGroups;
                        }

                        return prevGroups;
                    });
                });

                return () => {
                    if (newConnection) newConnection.stop();
                };
            }
        }


    }, [open, activeChatGroupId, roleId]);

    const showNotification = (messageObj) => {
        if (Notification.permission === "granted") {
            const notification = new Notification("ახალი შეტყობინება", {
                body: `${messageObj.creatorUserFullName}: ${messageObj.message}`,
            });

            notification.onclick = () => {
                window.focus();
            };
        }
    };

    const sendMessage = async () => {
        if (!currentMessage.trim()) return;

        setMessageSending(true);

        let payload = {
            chatGroupId: activeChatGroupId,
            message: currentMessage,
            seenThisMessageUserIds: [
                userId
            ],
            creatorUserID: userId,
            creatorUserFullName: `${users.find(user => user.id === userId).firstName} ${users.find(user => user.id === userId).lastName}`
        };

        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async () => {
                payload.file = {
                    base64String: reader.result.split(',')[1],
                    ext: file.name.split('.').pop()
                };
                await sendToBackend(payload);
                setTimeout(() => {
                    if (scrollRef.current) {
                        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
                    }
                }, 1);
            };
            reader.onerror = error => {
                console.error('Error converting file:', error);
            };
        } else {
            await sendToBackend(payload);
            setTimeout(() => {
                if (scrollRef.current) {
                    scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
                }
            }, 1);
        }


    };


    const sendMessageForSignaler = async (filePath) => {
        if (!currentMessage.trim() || !connection) return;
        const creatorUserFullName = users.find(user => user.id === userId);
        const createdAt = new Date().toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
        setMessageSending(true);
        const messageData = {
            message: filePath ?
                `message-$-${currentMessage}+&*creatorUserID-$-${userId}+&*createdAt-$-${createdAt}+&*creatorUserFullName-$-${creatorUserFullName.firstName} ${creatorUserFullName.lastName}+&*chatGroupId-$-${activeChatGroupId}+&*fipePath-$-${filePath} ` :
                `message-$-${currentMessage}+&*creatorUserID-$-${userId}+&*createdAt-$-${createdAt}+&*creatorUserFullName-$-${creatorUserFullName.firstName} ${creatorUserFullName.lastName}+&*chatGroupId-$-${activeChatGroupId} `
        };

        try {
            await connection.invoke("SendMessage", messageData);
            setCurrentMessage('');

        } catch (error) {
            console.error('Failed to send message:', error);
        } finally {
            setMessageSending(false);
        }
    };
    const getChatName = (chatName, userId) => {
        if (chatName.includes('-separator-')) {
            const parts = chatName.split('-separator-');

            const firstUserId = parts[0].split('-userId: ')[1].trim();
            const secondUserId = parts[1].split('-userId: ')[1].trim();

            const firstUser = users.find(user => user.id === firstUserId);
            const secondUser = users.find(user => user.id === secondUserId);

            const firstUserName = firstUser ? `${firstUser.firstName} ${firstUser.lastName}` : "User not found";
            const secondUserName = secondUser ? `${secondUser.firstName} ${secondUser.lastName}` : "User not found";

            if (firstUserId === userId) {
                return secondUserName;
            } else {
                return firstUserName;
            }
        }

        return chatName;
    };


    const sendToBackend = async (payload) => {
        try {
            const messageResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewChatMessage`, payload);
            await sendMessageForSignaler(messageResponse.data.fileUrl);
            setCurrentMessage('');
            setFile(null); // Reset the file input after sending
        } catch (error) {
            console.error('Failed to send message:', error);
        } finally {
            setMessageSending(false);
        }
    };

    useEffect(() => {
        if (initialLoadComplete.current && scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            initialLoadComplete.current = false;
        }
    }, [messages]);

    const fetchMessages = async (initialLoad = false) => {
        if (loading) return;
        setLoading(true);
        try {
            if (!activeChatGroupId) {
                return
            }
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/GetMessagesByChatGroupId?ChatGroupId=${activeChatGroupId}&PageSize=100&Page=${pageRef.current}`
            );
            if (response.data.success) {
                const newMessages = response.data.data.reverse();

                setMessages((prevMessages) =>
                    initialLoad ? newMessages : [...newMessages, ...prevMessages]
                );

                if (newMessages.length < 10) {
                    setHasMore(false);
                } else {
                    pageRef.current += 1;
                }

                if (initialLoad) {
                    initialLoadComplete.current = true;
                }
            }
        } catch (error) {
            console.error('Failed to fetch messages:', error);
        } finally {
            setLoading(false);
        }
    };
    const uniqueMessages = messages.reduce((acc, message) => {
        if (message.id === undefined) {
            acc.unique.push(message);
        } else {
            if (!acc.seenIds.has(message.id)) {
                acc.seenIds.add(message.id);
                acc.unique.push(message);
            }
        }
        return acc;
    }, {seenIds: new Set(), unique: []}).unique;

    const handleScroll = () => {
        if (scrollRef.current.scrollTop === 0 && hasMore && !loading && !initialLoadComplete.current) {
            const prevHeight = scrollRef.current.scrollHeight;
            fetchMessages().then(() => {
                scrollRef.current.scrollTop = scrollRef.current.scrollHeight - prevHeight;
            });
        }
    };

    const handleClose = () => {
        setActiveChatGroupId(null)
        pageRef.current = 0;
        setMessages([])
        void updateSeenMessages(activeChatGroupId)
        onClose();
    };


    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth={false}
            PaperProps={{
                sx: {
                    width: isCaseChat ? 1550 : 1650,
                    maxWidth: 'none',
                    borderRadius: 5,
                },
            }}
        >
            <div style={{
                height: isCaseChat ? 65 : 50,
                backgroundColor: '#1976d2',
                display: 'flex',
                alignItems: 'center'
            }}>
                {isCaseChat && (
                    <ChatComponentHeader groupUsers={groupUsers} users={users} caseNumber={chatName} groupId={mainGroup}
                                         handleEditChatGroup={handleEditChatGroup}/>
                )}
                <Tooltip title={'დახურვა'}>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        style={{position: 'absolute', right: 15, top: 8}}
                    >
                        <CloseIcon/>
                    </IconButton>
                </Tooltip>
            </div>
            <DialogContent style={{padding: 0}}>
                <div style={{display: "flex"}}>
                    {!isCaseChat ? (
                        <>
                            {chatGroupsAreLoading ? (
                                <div className="chat-list-container"><CircularProgress/></div>
                            ) : (
                                <div className="chat-list-container ">
                                    <div className="messenger-selector-header">
                                        <MdGroup size={24} className="messenger-selector-icon"/>
                                        ჩემი ჩატები

                                    </div>
                                    <div onClick={toggleCreateOneToOneChatPopup} className="one-to-one-chat">
                                        <FiUser style={{marginRight: '8px'}}/> ჩატის შექმნა
                                    </div>
                                    <div onClick={toggleCreateChatPopup} className="group-chat">
                                        <FiUsers style={{marginRight: '8px'}}/> ჯგუფური ჩატის შექმნა
                                    </div>
                                    <div style={{padding: '3px'}}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            placeholder="ჩატის ძებნა..."
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            style={{margin: '10px 0'}}
                                        />
                                    </div>
                                    <div className="chat-ul-container custom-scrollbar">
                                        <ul className="messenger-selector-group-list ">
                                            <ul className="messenger-selector-group-list">
                                                {chatGroups.length > 0 ? (
                                                    chatGroups
                                                        .filter(group => group.chatName.toLowerCase().includes(searchQuery.toLowerCase()))
                                                        .map((group) => (
                                                            <li
                                                                key={group.id}
                                                                onClick={() => handleChatGroupClick(group.id)}
                                                                className={`messenger-selector-group-item ${activeChatGroupId === group.id ? 'messenger-selector-group-item-active' : ''}`}
                                                            >
                                                                <div style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center'
                                                                }}>
                                                                    <span>{getChatName(group.chatName, userId)}</span>
                                                                    {group.notSeeenMessages > 0 && (
                                                                        <span style={{
                                                                            backgroundColor: '#f44336',
                                                                            color: '#fff',
                                                                            borderRadius: '12px',
                                                                            padding: '2px 8px',
                                                                            fontSize: '12px',
                                                                            marginLeft: '10px'
                                                                        }}>
                                                                            {group.notSeeenMessages}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                                <Tooltip title={"ჩატის პარამეტრები"}>
                                                                    <div>
                                                                        <MdOutlineEditNote
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleEditChatGroup(group);
                                                                            }}
                                                                            style={{
                                                                                float: 'right',
                                                                                fontSize: 30,
                                                                                backgroundColor: 'lightgrey',
                                                                                borderRadius: 5
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </Tooltip>
                                                            </li>
                                                        ))
                                                ) : (
                                                    <li className="messenger-selector-no-active-groups">
                                                        <FaTimesCircle style={{
                                                            marginRight: '10px',
                                                            verticalAlign: 'middle',
                                                            color: '#DC143C',
                                                            fontSize: '24px'
                                                        }}/>
                                                        თქვენ არ გაქვთ აქტიური ჩატები!
                                                    </li>
                                                )}
                                            </ul>
                                            {chatGroups.filter(group => group.chatName.toLowerCase().includes(searchQuery.toLowerCase())).length === 0 && searchQuery && (
                                                <li className="messenger-selector-no-results">
                                                    <FaTimesCircle style={{
                                                        marginRight: '10px',
                                                        verticalAlign: 'middle',
                                                        color: '#DC143C',
                                                        fontSize: '24px'
                                                    }} />
                                                    შედეგები ვერ მოიძებნა!
                                                </li>
                                            )}


                                        </ul>
                                    </div>
                                </div>
                            )

                            }
                        </>
                    ) : (

                        <div className="chat-list-empty-placeholder"></div>
                    )}


                    <div>

                        <div>
                        <Paper
                                className="custom-scrollbar"
                                style={{
                                    height: uniqueMessages.length === 0 ? 600 : 550,
                                    overflow: 'auto',
                                    padding: 20,
                                    minWidth: 1300,
                                    borderRadius: 2,
                                    border: '1px solid #ddd',

                                }}
                                ref={scrollRef}
                                onScroll={handleScroll}
                            >
                                <List style={{marginBottom: 20}}>
                                    {uniqueMessages.length > 0 || isCaseChat ? (
                                        uniqueMessages.filter(message => parseInt(message.chatGroupId) === activeChatGroupId && message.message !== '27015*&*&')
                                            .map((message) => (
                                                <div key={message.id}
                                                     className={`message-container ${message.creatorUserID === userId ? 'user-message' : 'other-message'}`}>
                                                    <div className="message-header">{message.creatorUserFullName}</div>
                                                    <div className="message-content">{message.message}</div>
                                                    {message.fipePath && (
                                                        <div className="message-filePath"
                                                             onClick={() => window.open(message.fipePath, '_blank')}>
                                                            <Tooltip
                                                                title={`.${message.fipePath.split('.').pop().toLowerCase()}`}>
                                                                <span
                                                                    className="icon-wrapper">{fileIcon(message.fipePath)}
                                                                </span>
                                                            </Tooltip>
                                                            ფაილის გადმოწერა
                                                        </div>
                                                    )}
                                                    <div className="message-time">{message.createdAt}</div>
                                                    {message.createAt && (
                                                        <div className="message-time">
                                                            {new Date(message.createAt).toLocaleString('en-GB', {
                                                                day: '2-digit',
                                                                month: '2-digit',
                                                                year: 'numeric',
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                second: '2-digit',
                                                                hour12: false
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            ))
                                    ) : (
                                        <div className="no-message-container">
                                            <MdArrowBack className="no-message-icon" size={40}/>
                                            <p className="no-message-text">აირჩიეთ ჩატი!</p>
                                            <p>ან შექმენით ახალი</p>
                                            <div className="no-message-action"
                                                 onClick={() => setShowCreateChatPopup(true)}>
                                                ჩატის შექმნა
                                                <FaCommentDots
                                                    style={{marginLeft: '8px', verticalAlign: 'middle'}}/>
                                            </div>
                                        </div>

                                    )}

                                </List>

                                {loading && <div className="messages-loading-container"><CircularProgress/></div>}
                            </Paper>
                            <div style={{display: "flex", gap: 10, marginTop: 20}}>
                                <div style={{width: "100%"}}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        multiline
                                        rows={5}
                                        value={currentMessage}
                                        onChange={handleChange}
                                        placeholder="შეტყობინება..."
                                        disabled={messageSending || !connection}
                                        onKeyDown={handleKeyDown}  // Attach the function here
                                        inputProps={{maxLength: 2024}}
                                        style={{marginBottom: '10px'}}
                                    />
                                    <div>
                                        {(messages.length !== 0 || isCaseChat) && (
                                            <div className="messenger-button-container">
                                                <Tooltip title={"სმაილები"}>
                                                    <button
                                                        onClick={() => setEmojiPickerVisible(!emojiPickerVisible)}
                                                        className="messenger-button-emoji">
                                                        😀
                                                    </button>
                                                </Tooltip>

                                                <Tooltip title={"ფაილის ატვირთვა"}>
                                                    <button
                                                        onClick={() => document.getElementById('file-upload').click()}
                                                        className="messenger-button-file-upload">
                                                        <MdFileUpload size={24}/>
                                                        <input
                                                            id="file-upload"
                                                            type="file"
                                                            hidden
                                                            onChange={handleFileChange}
                                                        />
                                                    </button>
                                                </Tooltip>
                                                {file && (
                                                    <>

                                                        <Tooltip title={"ფაილის ნახვა"}>
                                                            <button
                                                                onClick={() => window.open(filePreviewUrl, '_blank')}
                                                                className="messenger-button-file-view">
                                                                <MdVisibility size={24}/>
                                                            </button>
                                                        </Tooltip>
                                                        <Tooltip title={"ფაილის წაშლა"}>
                                                            <button onClick={() => {
                                                                setFile(null);
                                                                setFilePreviewUrl(null);
                                                                resetFileInput(); // Reset the input when the file is removed
                                                            }} className="messenger-button-file-delete">
                                                                <MdDelete size={24}/>
                                                            </button>
                                                        </Tooltip>
                                                    </>
                                                )}
                                                {file && (
                                                    <div className="messenger-file-name-container"
                                                         onClick={() => window.open(filePreviewUrl, '_blank')}>
                                                        <MdAttachEmail className="messenger-file-icon"/>
                                                        ფაილი: {file.name}
                                                    </div>
                                                )}
                                                {fileError && (
                                                    <div className="file-error-container">
                                                        <MdError size={20} className="file-error-icon"/>
                                                        <span>{fileError}</span>
                                                    </div>
                                                )}
                                                <div
                                                    className={`messenger-button-message-length ${
                                                        currentMessage.length > 2000 ? 'near-limit' :
                                                            currentMessage.length === 2024 ? 'at-limit' : ''
                                                    }`}
                                                    style={{
                                                        color: currentMessage.length === 2024 ? "red" :
                                                            currentMessage.length > 2000 ? "orange" : "grey"
                                                    }}
                                                >
                                                    {currentMessage.length} / 2024
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {emojiPickerVisible && (
                                        <div
                                            ref={emojiPickerRef}
                                            className={`emoji-picker ${
                                                emojiPickerVisible ? 'emoji-picker-enter' : 'emoji-picker-exit'
                                            }`}
                                            style={{
                                                position: 'absolute',
                                                right: 900,
                                                top: 425,
                                                padding: '8px',
                                                border: '1px dashed #ddd',
                                                backgroundColor: '#fff',
                                                borderRadius: '5px',
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                zIndex: 1000,
                                                marginLeft: 190,
                                            }}
                                        >
                                            <div style={{
                                                position: 'absolute',
                                                top: '0',
                                                right: '0',
                                                padding: '1px',
                                                cursor: 'pointer'
                                            }}>
                                                <IoIosCloseCircleOutline
                                                    size={24}
                                                    onClick={() => setEmojiPickerVisible(false)}
                                                />
                                            </div>
                                            {EMOJIS.map((emoji) => (
                                                <button key={emoji} onClick={() => addEmoji(emoji)}
                                                        className="emoji-button">
                                                    {emoji}
                                                </button>
                                            ))}
                                        </div>
                                    )}


                                </div>

                                <Tooltip
                                    title={(messageSending || !currentMessage.trim()) ? "" : "გაგზავნა (Enter)"}>
                                    <button
                                        className="messenger-send-button"
                                        onClick={sendMessage}
                                        disabled={messageSending || !currentMessage.trim()}
                                    >
                                        <MdSend className="messenger-send-icon"/>
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
            {showCreateChatPopup && users.length !== 0 && userId && (
                <CreateChatGroupPopup
                    open={showCreateChatPopup}
                    onClose={toggleCreateChatPopup}
                    users={users}
                    onChatCreate={fetchChatGroups}
                    userId={userId}
                />
            )}
            {showCreateOneToOneChatPopup && users.length !== 0 && userId && (
                <CreateChatOneToOne
                    open={showCreateOneToOneChatPopup}
                    onClose={toggleCreateOneToOneChatPopup}
                    users={users}
                    onChatCreate={fetchChatGroups}
                    userId={userId}
                />
            )}
            {showEditChatPopup && userId && users.length !== 0 && (
                <EditChatGroupPopup
                    open={showEditChatPopup}
                    onClose={toggleEditChatPopup}
                    onChatEdit={isCaseChat ? onCaseChatUpdate : fetchChatGroups}
                    group={selectedGroup}
                    userId={userId}
                    users={users}
                    isCaseChat={isCaseChat}
                />
            )}

        </Dialog>
    );
};

export default ChatComponent;